import React from 'react'
import { CFooter } from '@coreui/react'

const AppFooter = ({user}: any) => {
  const year = new Date().getFullYear();
  const url = window.origin.replace("office.", "").replace("stg.", "");
  return (
    <CFooter className="px-4">
      <div>
        <a href={url} target="_blank" rel="noopener noreferrer">
          {user.title}
        </a>
        <span className="ms-1">{user.company.replace(user.title, "")} &copy; {year} </span>
      </div>
      <div className="ms-auto">
        <span className="me-1">Developed by</span>
        <a href="https://kavitasharma.vercel.app/" target="_blank" rel="noopener noreferrer">
          Kavita Sharma
        </a>
      </div>
    </CFooter>
  )
}

export default React.memo(AppFooter)
